import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import { messageCountLoadEpicReducer } from "./messageCount.duck.js";
import { convertMessages } from "../../../utils/CommonUtil.js";
import { reduxActionTypePrefix, reduxKeys } from "../constants/constants.js";
import MessagesResource from "../resources/Messages.resource.js";
const actionTypesPrefix = reduxActionTypePrefix + "/loadUpsellMessageList";
const upsellMessageListLoadEpicReducerArg = {
  actionPrefix: actionTypesPrefix,
  reduxKeyNested: () => [reduxKeys.items],
  loadResource: (request) => MessagesResource.getUpsellMessageList(request.workspaceId, request.loadCount),
  onCompleteSuccess: (resourcesResult, inputPayload) => convertMessages(resourcesResult),
  afterActionsOnSuccess: (inputPayload, outputPayload) => refreshCount(inputPayload, outputPayload)
};
const refreshCount = (inputPayload, outputPayload) => [
  messageCountLoadEpicReducer.actionCreators.load({
    workspaceId: inputPayload.workspaceId,
    lastMessageId: inputPayload.lastMessageId
  })
];
const upsellMessageListLoadEpicReducer = loadResourcesUtils(upsellMessageListLoadEpicReducerArg);
const upsellMessageListReducerStateDefault = {
  items: getDefaultAsyncWrapperObj()
};
const upsellMessageListReducer = (state = upsellMessageListReducerStateDefault, action) => {
  state = upsellMessageListLoadEpicReducer.reduxChange(state, action);
  return state;
};
export {
  upsellMessageListReducer as default,
  upsellMessageListLoadEpicReducer,
  upsellMessageListReducer,
  upsellMessageListReducerStateDefault
};
//# sourceMappingURL=upsellMessageList.duck.js.map
